import PageContainerHeader from 'src/components/PageContainerHeader';
import Iconify from 'src/components/Iconify';
import { MKT } from '../marketing.design';

// Header de barra sticky compacta, no mesmo padrao visual de Campanhas.js
// (icone p-2/rounded-lg, titulo text-sm, filtros inline no meio, acoes a
// direita) — via PageContainerHeader, o componente ja compartilhado por 10+
// telas do app. Contraste com MktPageHeader (hero grande, sem filtros
// inline): esta e a variante pra paginas de listagem com filtros no header.
// iconVariant='brand': mesma regra do MktPageHeader — logo de terceiro sai na
// cor da marca, sobre superficie neutra, sem o tint violeta dos icones de UI.
export default function MktCompactHeader({ icon, iconVariant = 'accent', title, onBack, middle, right, badges }) {
    const isBrand = iconVariant === 'brand';
    return (
        <PageContainerHeader
            titleSection={(
                <div className="flex items-center gap-2 min-w-0">
                    {onBack && (
                        <button type="button" onClick={onBack} className={MKT.compactHeader.backBtn}>
                            <Iconify icon="eva:arrow-back-outline" width={16} />
                        </button>
                    )}
                    <div className={isBrand ? MKT.compactHeader.iconBoxBrand : MKT.compactHeader.iconBox}>
                        <Iconify
                            icon={icon}
                            width={isBrand ? 20 : 18}
                            className={isBrand ? undefined : MKT.compactHeader.icon}
                        />
                    </div>
                    <h3 className={MKT.compactHeader.title}>{title}</h3>
                    {badges && <div className="flex items-center gap-1.5 flex-shrink-0">{badges}</div>}
                </div>
            )}
            middleSection={middle}
            rightSection={right}
        />
    );
}
